module.exports = __webpack_public_path__ + "img/product-m-table.7026c01c.png";